import {
  Text,
  IconArrowUpRight,
  IndigoIndigo60,
  Primary13Regular,
  Flex,
  Link
} from '@sequencehq/core-components'
import { XERO_MAPPING_SETTINGS_ROUTE } from 'Products/constants/xeroMapping.constants'

type ConfigureXeroMappingsLinkProps = {
  'data-testid'?: string
}

export const ConfigureXeroMappingsLink = ({
  'data-testid': dataTestId
}: ConfigureXeroMappingsLinkProps) => (
  <Link.Unstyled to={XERO_MAPPING_SETTINGS_ROUTE} data-testid={dataTestId}>
    <Flex alignItems="center" gap={1}>
      <Text {...Primary13Regular} color={IndigoIndigo60}>
        Configure Xero mappings
      </Text>
      <IconArrowUpRight style={{ display: 'inline', color: IndigoIndigo60 }} />
    </Flex>
  </Link.Unstyled>
)
